var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('div',{staticClass:"form-wrap"},[_vm._t("default")],2),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }